import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import firebase from "./app.module";

type IECompatibleWindow = Window & {
  document: Document & {
    frames?: {
      devicePixelRatio: number;
      screen: {
        deviceXDPI: number;
        systemXDPI: number;
      };
    };
  };
};



@Injectable({
  providedIn: 'any'
})
export class SignPdfService {
  private modals: any[] = [];

  private showNav$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  private peopleInvitationData$: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  private selectedUser$: BehaviorSubject<any> = new BehaviorSubject<any>(1);
  
  constructor(private http:HttpClient,public router: Router) { 
    this.pdfUrl2 = this.pdfUrl;
    router.events.subscribe(() => {
      this.setShowNav(false);
    });
    
  }

  
  create(path: string, data: any) {
    return firebase.collection(path).add(data);
  }

  getSelectedUserData(){
    return this.selectedUser$.asObservable();
  }
  setSelectedUserData(data: any) {
    this.selectedUser$.next(data);
  }
  isSelectedUserData() {
    return this.selectedUser$.value;
  }
  getPeopleInvitationData(){
    return this.peopleInvitationData$.asObservable();
  }
  setPeopleInvitationData(data: any) {
    this.peopleInvitationData$.next(data);
  }
  isPeopleInvitationData() {
    return this.peopleInvitationData$.value;
  }

  getShowNav(){
    return this.showNav$.asObservable();
  }

  setShowNav(showHide: boolean) {
    this.showNav$.next(showHide);
  }

  toggleNavState() {
    this.showNav$.next(!this.showNav$.value);
  }

  isNavOpen() {
    return this.showNav$.value;
  }

  get_all(path: string) {
    return firebase.collection(path)
  }

  get_one(path: any, id: any) {
    return firebase.collection(path).doc(id)
  }

  update(path: any, id: any, data: any) {
    return firebase.doc(path + id).update(data);
  }

  delete(path: any, id: any) {
    return firebase.doc(path + id).delete();
  }

  
  signImageType = new BehaviorSubject<any>("");
  signImageData = this.signImageType.asObservable();
  pdfFormType = new BehaviorSubject<any>({});
  pdfFormData = this.pdfFormType.asObservable();
  pdfUrl2='';
  pdfUrl:any = `data:application/pdf;base64,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`

  imgUrl = `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyAQMAAAAk8RryAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAANQTFRFAAAAp3o92gAAAAF0Uk5TAEDm2GYAAAAOSURBVHicY2AYBYMJAAABkAAB07sQ/gAAAABJRU5ErkJggg==`
  
  lineImgUrl = `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAlgAAAJYCAYAAAC+ZpjcAAAABmJLR0QA/wD/AP+gvaeTAAAFzklEQVR4nO3WQQ2AQBAEQSCIPgm4BhOTm4StUtDPPg4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAdjnbAQVPOwAABlrtgJ0mDtbbDgCAgUY9x9UOAAD4G4MFABBmsAAAwgwWAECYwQIACDNYAABhBgsAIMxgAQCEGSwAgDCDBQAQZrAAAMIMFgBAmMECAAi72wEFqx0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAxgctcgKZyrQIpAAAAABJRU5ErkJggg==`


  setSignImageData(val: any) {
    this.signImageType.next(val);
  }
  setPdfFormData(val: any) {
    this.signImageType.next(val);
  }
  showSuccess(msg:any) {
    console.log(msg);
  }
  showError(msg:any) {
    console.log(msg);
  }
  showInfo(msg:any) {
    console.log(msg);
  }
  makeid(length:any) {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
       result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
 }
 public getIPAddress(url:any)  
 {  
   return this.http.get(url);  
 }  
 // modal
    add(modal: any) {
        
        this.modals.push(modal);
    }

    remove(id: string) {
       
        this.modals = this.modals.filter(x => x.id !== id);
    }

    open(id: string) {
       
        const modal = this.modals.find(x => x.id === id);
        modal.open();
    }

    close(id: string) {
       
        const modal = this.modals.find(x => x.id === id);
        modal.close();
    }
  
  zoomLevelDetector(
    matchMedia: Window['matchMedia'],
    currentLevel: number,
    minimalLevel: number,
    stepDivisor: number,
  ): number {
    while (currentLevel >= minimalLevel && !matchMedia(`(min-resolution: ${currentLevel / stepDivisor}dppx)`).matches) {
      currentLevel--;
    }
  
    return currentLevel;
  }
  
   calculatePageZoomLevel(win: Window): number {
    const mm = win.matchMedia;
    let startLevel = 10;
    let minLevel = 0.1;
    let stepDivisor = 1;
    let level = startLevel;
  
    for (let i = 0; i < 4; i++) {
      level = 10 * this.zoomLevelDetector(mm, startLevel, minLevel, stepDivisor);
  
      startLevel = level + 9;
      minLevel = level;
      stepDivisor *= 10;
    }
  
    return level / stepDivisor;
  }
  
 zoomLevel(win: IECompatibleWindow = window): number {
    if (!win) {
      return 1;
    }
  
    // For IE11+ and any
    if (typeof win.devicePixelRatio !== 'undefined') {
      return win.devicePixelRatio;
    }
  
    // For IE10
    const { frames } = win.document;
    if (typeof frames !== 'undefined') {
      if (typeof frames.devicePixelRatio !== 'undefined') {
        return frames.devicePixelRatio;
      }
  
      return frames.screen.deviceXDPI / frames.screen.systemXDPI;
    }
  
    // For any other browsers which does not support above
    if (typeof win.matchMedia !== 'undefined') {
      return this.calculatePageZoomLevel(win);
    }
  
    // fallback otherwise
    return 1;
  }
  
  elementZoomLevel(elementOrStyles: Element | CSSStyleDeclaration, win?: IECompatibleWindow): number {
    const zoom =
      (elementOrStyles instanceof Element ? getComputedStyle(elementOrStyles).zoom : elementOrStyles.zoom) || 1;
  
    return this.zoomLevel(win) * (typeof zoom === 'string' ? parseFloat(zoom) : zoom);
  }


}








